(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('product-info').forEach(function (productInfo) {
    // Keeps Format and Frame Color in a valid combination: Canvas always
    // pairs with "None", Framed always pairs with a real color. Without
    // this, switching Format can leave a stale, non-existent combination
    // selected (e.g. Canvas + Gold), which means Dawn can't resolve a
    // variant and the price disappears.
    function sync() {
      var formatField = productInfo.querySelector('[data-option-name="Format"]');
      var frameColorField = productInfo.querySelector('[data-option-name="Frame Color"]');
      if (!formatField || !frameColorField) return;

      var formatChecked = formatField.querySelector('input:checked');
      var format = formatChecked ? formatChecked.value : null;
      var colorChecked = frameColorField.querySelector('input:checked');
      var color = colorChecked ? colorChecked.value : null;

      var desiredValue = null;
      if (format === 'Canvas' && color !== 'None') {
        desiredValue = 'None';
      } else if (format === 'Framed' && (!color || color === 'None')) {
        desiredValue = 'Gold';
      }

      if (desiredValue) {
        var target = frameColorField.querySelector('input[value="' + desiredValue + '"]');
        if (target && !target.checked) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    sync();

    // Instant feedback on click
    productInfo.addEventListener('change', function (event) {
      if (event.target.closest('[data-option-name="Format"]')) sync();
    });

    // Dawn replaces the variant-selects DOM node on an async fetch after
    // every change (to refresh price/inventory). Re-sync whenever that
    // swap happens so the auto-selection survives it.
    var observer = new MutationObserver(function () {
      sync();
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

})();
